

const ValuerAmendTitle = (props) => {

    const value = props.value

    return (
        <div className="valuer-amend-accordion-title">
            {value && value}
        </div>
    )
}

export default ValuerAmendTitle;